/**
 * TAMWAJ — استبدال رمز العملة Dhs. بـ AED على واجهة المتجر
 *
 * تنسيق العملة إعداد على مستوى المتجر في Shopify، لا في القالب:
 *   الإعدادات ← عام ← تنسيق العملة
 * ضبطه هناك هو الحلّ الدائم لأنه يشمل صفحة الدفع ورسائل الطلب أيضًا،
 * وهذان لا يمرّان بالقالب إطلاقًا. ما هنا يغطّي الواجهة فورًا.
 *
 * نعمل على عُقد النص وحدها فلا نمسّ أي وسم أو سمة.
 */
(function () {
  var FROM = /\bDhs\.?( |\s)*/g;
  var TO = 'AED ';

  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, TEMPLATE: 1, CODE: 1, PRE: 1 };

  function convert(root) {
    if (!root || !root.nodeType) return;

    /* عُقدة نصية مفردة: TreeWalker لا يزور جذره، فنعالجها مباشرة */
    if (root.nodeType === 3) {
      if (root.nodeValue && root.nodeValue.indexOf('Dhs') !== -1) {
        var pn = root.parentNode;
        if (!pn || !SKIP[pn.nodeName]) root.nodeValue = root.nodeValue.replace(FROM, TO);
      }
      return;
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || node.nodeValue.indexOf('Dhs') === -1) return NodeFilter.FILTER_REJECT;
        var p = node.parentNode;
        if (!p || SKIP[p.nodeName]) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var hits = [], n;
    while ((n = walker.nextNode())) hits.push(n);

    for (var i = 0; i < hits.length; i++) {
      hits[i].nodeValue = hits[i].nodeValue.replace(FROM, TO);
    }
  }

  function run() { convert(document.body); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* الأسعار تتغيّر عند تبديل المتغيّر وفتح درج السلة وتحديث الكمية.
     كنّا نعيد مسح الصفحة كاملة عند أي تغيّر مهما صغر — وصفحة فيها
     المراجعات ونموذج الطلب والبكسلات تتغيّر عشرات المرات في الثانية،
     فكان كل إطار يجرّ مسحًا كاملًا للمستند. الآن نمسّ العُقد المتغيّرة
     وحدها. */
  var queue = [], pending = false;

  function flush() {
    pending = false;
    var nodes = queue;
    queue = [];
    for (var i = 0; i < nodes.length; i++) convert(nodes[i]);
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];

      if (m.type === 'characterData') {
        if (m.target.nodeValue && m.target.nodeValue.indexOf('Dhs') !== -1) queue.push(m.target);
        continue;
      }

      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1 || n.nodeType === 3) queue.push(n);
      }
    }

    if (!queue.length || pending) return;
    pending = true;
    requestAnimationFrame(flush);
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();
